import React, { useEffect, useState } from "react";
import {
  FaEnvelopeOpenText,
  FaEye,
  FaTrash,
  FaTimes,
  FaSearch,
  FaPhoneAlt,
  FaUserGraduate,
} from "react-icons/fa";
import API, { getData } from "../utils/api";

const Enquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [deleteEnquiryId, setDeleteEnquiryId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      setLoading(true);
      const data = await getData("/contact");
      setEnquiries(data.data || data || []);
    } catch (error) {
      console.log(error);
      alert(error.response?.data?.message || "Enquiries fetch failed");
    } finally {
      setLoading(false);
    }
  };

  const filteredEnquiries = enquiries.filter((item) => {
    const search = searchText.toLowerCase();

    return (
      item.fullName?.toLowerCase().includes(search) ||
      item.phone?.toLowerCase().includes(search) ||
      item.email?.toLowerCase().includes(search) ||
      item.enquiryType?.toLowerCase().includes(search) ||
      item.status?.toLowerCase().includes(search)
    );
  });

  const handleDelete = async () => {
    if (!deleteEnquiryId) return;

    try {
      const response = await API.delete(`/contact/${deleteEnquiryId}`);
      const data = response.data;

      if (data.success || data.message) {
        setEnquiries((prev) =>
          prev.filter((item) => item._id !== deleteEnquiryId)
        );
        setDeleteEnquiryId(null);
      }
    } catch (error) {
      console.log(error);
      alert(error.response?.data?.message || "Delete failed");
    }
  };

  return (
    <div className="space-y-5">
      <div className="bg-white rounded-2xl border border-[#D8E6FF] shadow-sm p-5 md:p-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
          <div>
            <h2 className="text-xl font-semibold text-[#073B7A]">
              Enquiries Management
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Manage all contact enquiries.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              <FaSearch className="absolute top-1/2 left-4 -translate-y-1/2 text-gray-400 text-sm" />
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search enquiry..."
                className="w-full md:w-72 pl-10 pr-4 py-3 rounded-xl border border-[#D8E6FF] outline-none text-sm focus:border-[#0B4EA2]"
              />
            </div>

            <div className="w-12 h-12 rounded-xl bg-[#FFF3C4] text-[#073B7A] flex items-center justify-center text-xl">
              <FaEnvelopeOpenText />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-[#D8E6FF] shadow-sm overflow-hidden">
        <div className="px-5 py-4 bg-[#073B7A] text-white flex items-center justify-between border-b-4 border-[#F6C344]">
          <div>
            <h3 className="text-lg font-semibold">Recent Enquiries</h3>
            <p className="mt-1 text-xs text-blue-50">
              View and manage enquiry submissions
            </p>
          </div>

          <div className="hidden md:flex items-center gap-2 bg-white/10 px-4 py-2 rounded-xl text-sm">
            <span>Total :</span>
            <span className="font-semibold">{filteredEnquiries.length}</span>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead>
              <tr className="bg-[#EEF5FF] text-[#073B7A]">
                <th className="px-5 py-4 text-left text-sm font-semibold">
                  S.No
                </th>
                <th className="px-5 py-4 text-left text-sm font-semibold">
                  Name
                </th>
                <th className="px-5 py-4 text-left text-sm font-semibold">
                  Phone
                </th>
                <th className="px-5 py-4 text-left text-sm font-semibold">
                  Email
                </th>
                <th className="px-5 py-4 text-left text-sm font-semibold">
                  Type
                </th>
                <th className="px-5 py-4 text-center text-sm font-semibold">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="6"
                    className="px-5 py-8 text-center text-[#073B7A] font-semibold"
                  >
                    Loading enquiries...
                  </td>
                </tr>
              ) : filteredEnquiries.length > 0 ? (
                filteredEnquiries.map((item, index) => (
                  <tr
                    key={item._id}
                    className="border-b border-[#E6EEF9] hover:bg-[#F8FBFF]"
                  >
                    <td className="px-5 py-4">{index + 1}</td>
                    <td className="px-5 py-4">{item.fullName || "-"}</td>
                    <td className="px-5 py-4">{item.phone || "-"}</td>
                    <td className="px-5 py-4">{item.email || "-"}</td>
                    <td className="px-5 py-4">
                      <span className="px-3 py-1 rounded-full text-xs bg-[#EEF5FF] text-[#073B7A] font-semibold">
                        {item.enquiryType || "New"}
                      </span>
                    </td>
                    <td className="px-5 py-4">
                      <div className="flex items-center justify-center gap-2">
                        <button
                          onClick={() => setSelectedEnquiry(item)}
                          className="w-9 h-9 rounded-lg bg-[#0B4EA2] text-white flex items-center justify-center"
                        >
                          <FaEye size={13} />
                        </button>

                        <button
                          onClick={() => setDeleteEnquiryId(item._id)}
                          className="w-9 h-9 rounded-lg bg-red-100 text-red-600 flex items-center justify-center"
                        >
                          <FaTrash size={13} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="px-5 py-8 text-center text-gray-500"
                  >
                    No enquiries found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {selectedEnquiry && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-lg rounded-3xl shadow-xl overflow-hidden">
            <div className="bg-[#073B7A] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="font-semibold text-lg">Enquiry Details</h3>
              <button onClick={() => setSelectedEnquiry(null)}>
                <FaTimes />
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div className="flex items-center gap-3">
                <FaUserGraduate className="text-[#073B7A]" />
                <span>{selectedEnquiry.fullName || "-"}</span>
              </div>

              <div className="flex items-center gap-3">
                <FaPhoneAlt className="text-[#073B7A]" />
                <span>{selectedEnquiry.phone || "-"}</span>
              </div>

              <div>
                <p className="font-semibold text-[#073B7A]">Email</p>
                <p className="text-gray-600">{selectedEnquiry.email || "-"}</p>
              </div>

              <div>
                <p className="font-semibold text-[#073B7A]">Enquiry Type</p>
                <p className="text-gray-600">
                  {selectedEnquiry.enquiryType || "-"}
                </p>
              </div>

              <div>
                <p className="font-semibold text-[#073B7A]">Message</p>
                <p className="text-gray-600">
                  {selectedEnquiry.message || "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteEnquiryId && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-md rounded-3xl shadow-xl p-6 text-center">
            <div className="w-16 h-16 rounded-full bg-red-100 text-red-600 mx-auto flex items-center justify-center text-2xl">
              <FaTrash />
            </div>

            <h3 className="mt-4 text-xl font-semibold text-[#073B7A]">
              Delete Enquiry?
            </h3>

            <p className="mt-2 text-sm text-gray-500">
              This enquiry will be permanently deleted.
            </p>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setDeleteEnquiryId(null)}
                className="flex-1 h-11 rounded-xl border border-[#0B4EA2] text-[#0B4EA2]"
              >
                Cancel
              </button>

              <button
                onClick={handleDelete}
                className="flex-1 h-11 rounded-xl bg-red-600 text-white"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Enquiries;